<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :href="to.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>ข้อมูลผู้ใช้งาน</div>
        <div>


          <v-btn
              class="mx-2"
              fab
              dark
              color="indigo"
              href="/UsersCreate"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
        </div>

      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :to="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <v-data-table
          :headers="headers"
          :items="resultData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
        </template>
        <template v-slot:item.image="{ item }">
          <img class="img_thumb" v-bind:src="baseUrl+'/'+item.image.path.replace('media','')"  >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="editItem(item.codes)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="deleteItem(item.codes)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-breadcrumbs>



</template>

<script>
import {DeleteUser, GetMachine, GetUser} from "../../lib/controller";
import {baseUrl} from "../../const/api";


export default {
  name: "Users",
  data: () => ({
    baseUrl:baseUrl,
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลผู้ใช้',
        disabled: true,
        href: '/Users',
      },
    ],
    dialog: false,
    dialogDelete: false,
    machine_id: JSON.parse(localStorage.getItem('user')).machine_id,
    machine_item: {},
    headers: [
      {
        text: 'รูปโปรไฟล์',
        align: 'start',
        sortable: false,
        value: 'image',
      },
      { text: 'ชื่อ', value: 'first_name' },
      { text: 'นามสกุล', value: 'last_name' },
      { text: 'แผนก', value: 'departments[0].title' },
      { text: 'RFID', value: 'rfidcode' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()
    this.getData()
    this.GetMachines()
  },

  methods: {
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        machine.push({
          "label":"ทั้งหมด",
          "id":99,
        })

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.machine_item)

    },
   async editItem(id) {
     this.$router.push({ path: '/Users/'+id })
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            this.delete(id)
        }
      })

      ;
    },
    initialize () {

    },
   async getData(){


     let params = {};

     if(this.machine_id !== 99){

       params.machine_id = this.machine_id
     }


      const { status,results } = await GetUser(params);
      if(status === 200){
        this.resultData = results.data;
      }
    },
    async delete(id){
      let Swal = this.$swal;
      const { status } = await DeleteUser(id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
       await this.getData()
      }
    },

  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
</style>
